import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon"];

  connect() {
    this.closeHandler = this.close.bind(this);
    document.addEventListener("turbo:before-visit", this.closeHandler);
    document.addEventListener("turbo:submit-start", this.closeHandler);
    // Past the lg breakpoint the fixed rail takes over; a drawer left open
    // while the window grew would come back open when it shrank again.
    this.desktop = window.matchMedia("(min-width: 1024px)");
    this.desktop.addEventListener("change", this.closeHandler);
    this.escapeHandler = this.closeOnEscape.bind(this);
    document.addEventListener("keydown", this.escapeHandler);
  }

  disconnect() {
    this.desktop.removeEventListener("change", this.closeHandler);
    document.removeEventListener("turbo:before-visit", this.closeHandler);
    document.removeEventListener("turbo:submit-start", this.closeHandler);
    document.removeEventListener("keydown", this.escapeHandler);
  }

  // The drawer covers the page, so Escape has to reach it.
  closeOnEscape(event) {
    if (event.key === "Escape") this.close();
  }

  toggle() {
    const isHidden = this.menuTarget.classList.toggle("hidden");
    this.openIconTarget.classList.toggle("hidden", !isHidden);
    this.closeIconTarget.classList.toggle("hidden", isHidden);
  }

  close() {
    this.menuTarget.classList.add("hidden");
    this.openIconTarget.classList.remove("hidden");
    this.closeIconTarget.classList.add("hidden");
  }
}
